import React from 'react';
import { AiTwotoneBuild } from 'react-icons/ai';

const placeholder = require('../placeholder.png');

const Build = () => {
  return (
    <div>
      <AiTwotoneBuild className="mx-auto text-3xl text-[#974D9B]" />
      <p className="mt-3 font-2xl text-slate-600">
        Discover softwares to help you setup smart solutions for your business
      </p>
      <img src={placeholder} alt="" className="w-[60%] mx-auto mt-5" />
    </div>
  );
};

export default Build;
